<div style="overflow-y: auto; overflow-x:hidden; height: 92vh;">
  <div class="card">
    <div class="card-header nocollapse">
      Matrix Questions
    </div>

    <div [hidden]="folderId == -1">
      <div class="bg-info p-1 mb-3">
        <div class="row">
          <div class="col-md-10">
            <span class="text-white pt-2" style="font-size:18px; display:inline-block"><b>Folder Name : </b>{{ folderName }}</span>
          </div>
          <div class="col-md-2 py-1">
            <button type="button" class="btn btn-primary btn-action" (click)="backToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-arrow-left"></i> Back to Section</button>
            <button type="button" class="btn btn-primary btn-action mb-0" (click)="backUrl()"><i class="fa fa-home"></i> Home</button>
          </div>
        </div>
      </div>
    </div>
    <div id="messageContainer" class="card-header nocollapse bg-info col-md-12 msg-container" style="display:none;">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <span id="message"></span>
    </div>
    <div class="col-md-12 card-body p-1">
      <form [formGroup]="questionForm" #f="ngForm">
        <div class="form-group">
          <table align="center" width="98%">
            <tr>
              <td width="60%">
                <div class="row mb-3">

                  <label data-required for="qsDescription" class="form-control-label col-md-3">Question Title<sup class="text-danger">&ast;</sup></label>
                  <div class="col-md-7">
                    <input type="text" id="qsDescription" name="qsDescription" formControlName="qsDescription" class="form-control" />
                    <small class="red" *ngIf="!questionForm.get('qsDescription')?.valid && !questionForm.get('qsDescription')?.hasError('required')">
                      Please enter the required (*) fields.
                    </small>
                  </div>
                </div>
              </td>
              <td width="20%">
                <table align="center" width="98%">
                  <tr>
                    <td width="5%"><input type="checkbox" id="isEveryRowMandatory" name="isEveryRowMandatory" formControlName="isEveryRowMandatory" class="form-check mt-1" /></td>
                    <td><label for="isEveryRowMandatory" class="form-control-label col-md-5 ps-2">Row Level Mandatory</label></td>
                  </tr>
                </table>
              </td>
              <td width="20%">
                <table align="center" width="98%">
                  <tr>
                    <td width="5%"><input type="checkbox" id="isHideRowHeader" name="isHideRowHeader" formControlName="isHideRowHeader" class="form-check mt-1" /></td>
                    <td><label for="isHideRowHeader" class="form-control-label col-md-5 ps-2">Hide Row Header</label></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td width="60%">
                <div class="row mb-3">
                  <label class="form-control-label col-md-3" for="questionCategoryId"> Category</label>
                  <div class="col-md-7">
                    <select name="questionCategoryId" id="questionCategoryId" formControlName="questionCategoryId" class="form-control custom-select-with-arrow">
                      <option value="" selected>--Select--</option>
                      <option *ngFor="let item of questionCategoryList" [ngValue]="item?.questionCategoryId" [selected]="questionCategoryId==item?.questionCategoryId">
                        {{item.questionCategoryName}}
                      </option>
                    </select>
                  </div>
                </div>
              </td>
              <td width="40%" colspan="2">
                <div class="row">
                  <div class="col-md-3">
                    <button type="button" class="btn btn-primary btn-action" style="margin-left: -80px;"
                            (click)="openCategoryModal()">
                      <i class="fa fa-plus"></i> Create Category
                    </button>
                  </div>
                  <label class="col-md-3 form-control-label" for="width">Row Width</label>
                  <div class="col-md-4"><input class="form-control" maxlength="1000" type="number" id="width" name="width" formControlName="width" placeholder="Width" /></div>
                </div>
              </td>
            </tr>

            <tr>
              <td width="60%">
                <div class="row mb-3">
                  <label class="form-control-label col-md-3" for="shortName">Short Name</label>
                  <div class="col-md-7"><input class="form-control" type="text" id="shortName" name="shortName" formControlName="shortName" placeholder="Short Name" /></div>
                </div>
              </td>
              <td width="20%"></td>
              <td width="20%"></td>
            </tr>
          </table>
        </div>




        <div class="row col-md-12">
          <div class="col-md-9"></div>
          <div class="col-md-3">
            <button type="button" class="btn btn-primary btn-action pull-right" (click)="addQuestion()"><i class="fa fa-plus"></i> Create / Update</button>
            <button type="submit" class="btn btn-secondary btn-action pull-right" (click)="backUrl()" [hidden]="redirectedSectionId!=null || redirectedSurveyId!=null"><i class="fa fa-times"></i> Cancel</button>
            <button type="button" class="btn btn-secondary btn-action pull-right" (click)="backToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-times"></i> Cancel</button>

          </div>
        </div>

      </form>
    </div>
    <div *ngIf="questionId > 0">
      <div class="row mb-3">
        <div class="col-md-6">
          <div class="card">
            <form [formGroup]="columnHeaderForm" #f="ngForm">
              <div class="card-header nocollapse">
                Column Header
              </div>
              <div id="columnHeader">
                <div class="row mt-3 mx-0">
                  <label data-required for="qsHeaderDescription" class="form-control-label col-md-3">Description <sup class="text-danger">&ast;</sup></label>
                  <div class="col-md-5">
                    <input type="text" id="qsHeaderDescription" name="qsHeaderDescription" formControlName="qsHeaderDescription"
                           class="form-control" />
                  </div>
                  <small class="red" *ngIf="!columnHeaderForm.get('qsHeaderDescription')?.valid && !columnHeaderForm.get('qsHeaderDescription')?.hasError('required')">
                    Please enter the required (*) fields.
                  </small>
                </div>
                <div class="page-attributes p-1 pull-right justify-content-end">
                  <button type="button" class="btn btn-secondary btn-action" (click)="resetHeaderForm()"><i class="fa fa-eraser"></i> Clear</button>
                  <button type="button" class="btn btn-primary btn-action" [disabled]="!columnHeaderForm.valid" (click)="addHeader()"><i class="fa fa-plus"></i>  Create / Update</button>
                  <button type="button" class="btn btn-primary btn-action" (click)="arrangeOrderColumnHeader()"><i class="fa fa-reorder"></i>Update Order</button>
                </div>
              </div>
            </form>
            <div class="p-1">
              <isg-grid [rowData]="columnHeaderList"
                        [columnDefs]="columnHeaderDefs"
                        [config]="columnHeaderGridConfig"
                        (gridReady)="onGridReady($event)">
              </isg-grid>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card">
            <div class="card-header nocollapse">
              Column Item
            </div>
            <div class="page-attributes p-1 mt-3 justify-content-end">
              <button type="button" [disabled]="(questionColumnHeaderList?.length ?? 0) > 0" class="btn btn-primary btn-action pull-right" (click)="openRangeColumnItemModal()"><i class="fa fa-plus"></i> Add Range</button>
              <button type="button" class="btn btn-primary btn-action pull-right" (click)="arrangeOrderColumnItem()"><i class="fa fa-reorder"></i> Update Order</button>
              <button type="button" class="btn btn-primary btn-action pull-right" (click)="AddColumnData(true)"><i class="fa fa-plus"></i> Create / Update</button>
            </div>
            <div id="columnItem" class="p-1">
              <isg-grid [rowData]="columnDataNew"
                        [columnDefs]="columnItemDefs"
                        [config]="columnItemGridConfig"
                        (gridReady)="onColumnGridReady($event)">
              </isg-grid>
            </div>
            <div *ngIf="showAddColumnModal" class="modal fade show d-block" id="columnItemModal" tabindex="-1" role="dialog" aria-labelledby="columnItemModal" [hidden]="hideColumnItemForm" aria-hidden="true">
              <div class="modal-dialog" role="document" style="max-width:950px;">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Add Column Item</h5>
                    <button type="button" class="btn-close" aria-label="Close" (click)="CloseModal()"></button>
                  </div>
                  <div class="col-md-12 card-body">
                    <form [formGroup]="columnItemForm" #f="ngForm">
                      <div id="columnItemMsgContainer" class="card-header nocollapse bg-info col-md-12 msg-container" style="display:none;">
                        <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
                        <span id="exception"></span>
                      </div>
                      <div class="row mb-3">
                        <label data-required for="columnItemDescription" class="form-control-label col-md-3">Column Item Description<sup class="text-danger">&ast;</sup></label>
                        <div class="col-md-9"><input type="text" id="columnItemDescription" name="columnItemDescription" formControlName="columnItemDescription" class="form-control" /></div>
                        <!--<small class="red" *ngIf="(!columnItemForm.valid && columnItemForm.touched) || (!columnItemForm.get('columnItemDescription')?.valid && !columnItemForm.get('columnItemDescription')?.hasError('required'))">
                          Please enter the required (*) fields.
                        </small>-->
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-3">
                          <label for="questionColumnHeaderId" class="form-control-label">Select Column Header </label>
                        </div>
                        <div class="col-md-6">
                          <div *ngFor="let columnHeader of questionColumnHeaderList">
                            <input class="form-check-input me-2" type="checkbox" id="{{columnHeader.questionColumnHeaderId}}" name="{{columnHeader.questionColumnHeaderId}}"
                                   (change)="updateSelectedColumnHeaders($event)" checked="{{ questionColumnHeaderId == columnHeader.questionColumnHeaderId && questionColumnItemId !== 0 ? 'checked' : '' }}" />
                            <label class="form-check-label">
                              {{columnHeader.qsHeaderDescription}}
                            </label>
                          </div>
                        </div>

                      </div>
                      <div class="row mb-3">
                        <label class="form-control-label col-md-3" for="controlTypeId">Control Type</label>

                        <div class="col-md-3">
                          <select name="controlTypeId" id="controlTypeId" formControlName="controlTypeId" (change)="onControlTypeChange()" class="form-control custom-select-with-arrow">
                            <option></option>
                            <option *ngFor="let type of controlTypeList" [ngValue]="type?.controlTypeId">
                              {{type.controlType}}
                            </option>
                          </select>
                        </div>
                        <label class="form-control-label col-md-2" for="dataTypeId">Data Type</label>
                        <div class="col-md-3">
                          <select name="dataTypeId" id="dataTypeId" formControlName="dataTypeId" class="form-control custom-select-with-arrow">
                            <option></option>
                            <option *ngFor="let data of dataTypeList" [ngValue]="data?.dataTypeId">
                              {{data.typeName}}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <label class="form-control-label col-md-3" for="picklistReferenceId">Picklist</label>
                        <div class="col-md-3">
                          <select name="picklistReferenceId" id="picklistReferenceId" formControlName="picklistReferenceId" class="form-control custom-select-with-arrow">
                            <option *ngFor="let item of picklistReferenceList" [ngValue]="item?.picklistReferenceId">
                              {{item.picklistReferenceDescription}}
                            </option>
                          </select>
                        </div>
                        <label for="minValue" class="form-control-label col-md-2">Min.Value</label>
                        <div class="col-md-1"><input type="text" id="minValue" name="minValue" formControlName="minValue" class="form-control" /></div>
                        <label for="maxValue" class="form-control-label col-md-2">Max.Value</label>
                        <div class="col-md-1"><input type="text" id="maxValue" name="maxValue" formControlName="maxValue" class="form-control" /></div>
                      </div>
                      <div class="row pl-lg-1 mb-3">
                        <div class="col-md-3">
                          <div class="form-check">
                            <input type="checkbox" id="isMandatory" name="isMandatory" formControlName="isMandatory" class="form-check-input" />
                            <label for="isMandatory" class="form-check-label">Mandatory</label>
                          </div>
                        </div>

                        <div class="col-md-3">
                          <div class="form-check">
                            <input type="checkbox" id="isEnabled" name="isEnabled" formControlName="isEnabled" class="form-check-input" />
                            <label for="isEnabled" class="form-check-label">Enabled</label>
                          </div>
                        </div>
                        <div class="col-md-6 row">
                          <div class="col-md-4">
                            <label for="width" class="form-control-label">Width</label>
                          </div>
                          <div class="col-md-6 ms-2">
                            <input type="text" id="width"  formControlName="width" name="width" class="form-control" />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="card-footer d-flex justify-content-end">
                    <button type="button" class="btn btn-secondary btn-action" (click)="CloseModal()"><i class="fa fa-times"></i> Close</button>
                    <button type="button" id="btnSave" class="btn btn-primary btn-action" (click)="saveColumnItem()"><i class="fa fa-save"></i> Save</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <div class="card" style="min-height:475px;">
            <form [formGroup]="rowItemForm" #f="ngForm">
              <div class="card-header nocollapse">
                Row Item
              </div>
              <div id="rowItemHeader">
                <div class="row mb-3 mx-0 mt-3">
                  <label data-required for="rowItemHeaderDescription" class="form-control-label col-md-3">Description  <sup class="text-danger">&ast;</sup></label>
                  <div class="col-md-5"><input type="text" id="rowItemHeaderDescription" name="rowItemHeaderDescription" formControlName="rowItemHeaderDescription" class="form-control" /></div>
                  <small class="red" *ngIf="!rowItemForm.get('rowItemHeaderDescription')?.valid && !rowItemForm.get('rowItemHeaderDescription')?.hasError('required')">
                    Please enter the required (*) fields.
                  </small>
                </div>

                <div class="page-attributes p-1 justify-content-end">
                  <button type="button" class="btn btn-secondary btn-action" (click)="resetRowItemForm()"><i class="fa fa-eraser"></i> Clear</button>
                  <button type="button" class="btn btn-primary btn-action" [disabled]="!rowItemForm.valid" (click)="addRowItem()"><i class="fa fa-plus"></i> Create / Update </button>
                  <button type="button" class="btn btn-primary btn-action" (click)="arrangeOrderRowItem()"><i class="fa fa-reorder"></i>Update Order</button>
                </div>
              </div>
            </form>
            <div class="p-1">
              <isg-grid [rowData]="rowItemList"
                        [columnDefs]="rowItemDefs"
                        [config]="rowItemGridConfig"
                        (gridReady)="onRowGridReady($event)">
              </isg-grid>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card">
            <form [formGroup]="questionDefaultValueForm" #f="ngForm">
              <div class="card-header nocollapse">
                Default Value
              </div>

              <div class="row mb-3 mx-0 mt-3">
                <label data-required for="defaultValue" class="form-control-label col-md-4">Default Value<sup class="text-danger">&ast;</sup></label>
                <div class="col-md-7"><input type="text" id="defaultValue" name="defaultValue" formControlName="defaultValue" class="form-control" /></div>
                <small class="red" *ngIf="!questionDefaultValueForm.get('defaultValue')?.valid && !questionDefaultValueForm.get('defaultValue')?.hasError('required')">
                  Please enter the required (*) fields.
                </small>
              </div>
              <div class="row mb-3 mx-0">
                <label data-required form="questionColumnItemId" class="form-control-label col-md-4" for="questionColumnItemId">Column Item<sup class="text-danger">&ast;</sup></label>
                <div class="col-md-8">
                  <select name="questionColumnItemId" id="questionColumnItemId" formControlName="questionColumnItemId" class="form-control custom-select-with-arrow">
                    <option value="" selected></option>
                    <option *ngFor="let columnItem of columnDataNew" [ngValue]="columnItem?.questionColumnItemId">
                      {{columnItem.columnItemDescription}}~{{columnItem.questionColumnHeaderName}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row mb-3 mx-0">
                <label data-required form="questionRowItemId" class="form-control-label col-md-4" for="questionRowItemId">Row Item<sup class="text-danger">&ast;</sup></label>
                <div class="col-md-8">
                  <select name="questionRowItemId" id="questionRowItemId" formControlName="questionRowItemId" class="form-control custom-select-with-arrow">
                    <option value="" selected></option>
                    <option *ngFor="let rowItem of rowItemList" [ngValue]="rowItem?.rowItemHeaderId">
                      {{rowItem.rowItemHeaderDescription}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="page-attributes p-1 justify-content-end">
                <button type="button" class="btn btn-secondary btn-action" (click)="resetDefaultValueForm()"><i class="fa fa-eraser"></i> Clear </button>
                <button type="button" [disabled]="!questionDefaultValueForm.valid" class="btn btn-primary btn-action" (click)="addQuestionDefaultValue()"><i class="fa fa-plus"></i> Create / Update </button>
              </div>
            </form>
            <div class="p-1">
              <isg-grid [rowData]="questionDefaultValueList"
                        [columnDefs]="questionDefaultValueDefs"
                        [config]="defaultValueGridConfig"
                        (gridReady)="onDefaultValueGridReady($event)">
              </isg-grid>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<ng-template #deleteRowItemModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Row Item confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="form-control-label">
      Are you sure you want to delete this Row Item ?
    </div>
    <br />
    <div class="red form-control-label">
      <b>Note: </b><br />
      The user response for this particular Row Item also will be deleted.<br />
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="deleteRowItem(); modal.close()" class="btn btn-danger btn-modal"><i class="fa fa-trash"></i> Delete</button>
    <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()"><i class="fa fa-times"></i> Close</button>
  </div>
</ng-template>

<ng-template #deleteColumnHeaderModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Column Header Confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="form-control-label">
      Are you sure you want to delete this Column Header ?
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="deleteColumnHeader(); modal.close()" class="btn btn-danger btn-modal"><i class="fa fa-trash"></i> Delete</button>
    <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()"><i class="fa fa-times"></i> Close</button>
  </div>
</ng-template>

<ng-template #deleteColumnItemModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Column Item confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="form-control-label">
      Are you sure you want to delete this Column Item ?
    </div>
    <br />
    <div class="red form-control-label">
      <b>Note: </b><br />
      The user response for this particular Column Item also will be deleted.<br />
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="deleteColumnItem(); modal.close()" class="btn btn-danger btn-modal"><i class="fa fa-trash"></i> Delete</button>
    <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()"><i class="fa fa-times"></i> Close</button>
  </div>
</ng-template>

<ng-template #deleteDefaultValueModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Default Value confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="form-control-label">
      Are you sure you want to delete this Default Value ?
    </div>
    <br />
    <div class="red form-control-label">
      <b>Note: </b><br />
      The user response for this particular Default Value also will be deleted.<br />
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="deleteDefaultValue(); modal.close()" class="btn btn-danger btn-modal"><i class="fa fa-trash"></i> Delete</button>
    <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()"><i class="fa fa-times"></i> Close</button>
  </div>
</ng-template>

<ng-template #rangeColumnItemModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Add Range Column Item</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="col-md-12 card-body">
    <form [formGroup]="rangeColumnItemForm" #f="ngForm">
      <div id="columnItemMsgContainer" class="card-header nocollapse bg-info col-md-12 msg-container" style="display:none;">
        <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
        <span id="exception"></span>
      </div>
      <div class="form-group row">
        <label data-required for="startRange" class="form-control-label col-md-4">Start Range</label>
        <input type="text" id="startRange" name="startRange" formControlName="startRange" class="form-control-sm col-md-8" />
      </div>
      <div class="form-group row">
        <label data-required for="endRange" class="form-control-label col-md-4">End Range</label>
        <input type="text" id="endRange" name="startRange" formControlName="endRange" class="form-control-sm col-md-8" />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    <button type="button" class="btn btn-primary btn-modal" (click)="saveRangeColumnItem(); modal.close()"><i class="fa fa-save"></i> Save</button>
  </div>
</ng-template>

<ng-template #CreateCategoryModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title"> Create Category</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="ResetQuesCategoryForm(); modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <form [formGroup]="quesCategoryForm" #f="ngForm">
      <div class="row align-items-center">
        <label data-required class="col-md-4 form-control-label" for="quesCategoryName">Category</label>
        <div class="col-md-8">
          <input class="form-control" type="text" id="quesCategoryName" name="quesCategoryName" formControlName="quesCategoryName" placeholder="Category" />
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="ResetQuesCategoryForm(); modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    <button type="button" class="btn btn-primary btn-modal" [disabled]="!quesCategoryForm.valid" (click)="AddQuesCategory(); modal.close()"><i class="fa fa-save"></i> Save</button>
  </div>
</ng-template>
